import React, { useState, useEffect } from 'react';
import { UserOutlined, LockOutlined, HomeOutlined, DatabaseTwoTone, SoundTwoTone, HeartTwoTone, PlusOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Form, Input, Button, Checkbox, Card, notification, Row, Col, Typography, Select, Modal, DatePicker, AutoComplete, Divider, Radio, Popover, Alert } from 'antd';
import axios from 'axios'
import "antd/dist/antd.css";
import './App.css';
import { create, getall } from './api/api';
import Chart from "react-google-charts";
var qs = require('qs');
let sourceCode

const { Title, Text } = Typography;
const { Option } = Select;
const urldaskes = 'http://pkmsambas.sambas.go.id/api/'
const config = {
  rules: [{ type: 'object', required: true, message: 'Isikan Tanggal Lahir' }],
};
const configfield = {
  rules: [{ required: true, message: 'Please select time!' }],
};

const val = [
  {
    value: 'Burns Bay Road',
  },
  {
    value: 'Downing Street',
  },
  {
    value: 'Wall Street',
  },
];

function App() {
  const [showmodal, setShowmodal] = useState(false)
  const [isLogin, setLogin] = useState(false);

  // Attr Pasien
  const [nik, setNik] = useState('');
  const [rm, setRm] = useState('');
  const [nama, setNama] = useState('');
  const [bpjs, setBpjs] = useState('');
  const [jenis_kelamin, setJenisKelamin] = useState('')
  const [alamat, setAlamat] = useState('');
  const [tempat_lahir, setTempatlahir] = useState('')//tempatlahir
  const [tanggal_lahir, setTanggallahir] = useState('')//tanggal lahir
  const [no_hp, setNohp] = useState('')//nohp
  const [agama, setAgama] = useState('') //agama
  const [pekerjaan, setPekerjaan] = useState('')//pelerjaan
  const [status, setStatus] = useState('')//status
  const [faskes_id, setFaskesId] = useState('')
  const [nama_kepala_keluarga, setNamakepalakeluarga] = useState('')//namakk

  const [kodeAntrian, setKodeAntrian] = useState('')
  const [pasien, setPasien] = useState('')
  const [pasienforpoli, setPasienForPoli] = useState([])
  const [poli, setPoli] = useState('')
  const [onesignalid, setOnesignalid] = useState('9e3c5524-7a74-4b88-9a0f-846c3b4abf1b')
  const [onesignalsec, setOnesignalsec] = useState('NmExMDdiMDYtN2Y2Yi00N2VmLTkzNzktZGJiZDg3Y2U1ZjA0')
  const [dipanggil, setDipanggil] = useState('0');
  const [sisa, setSisa] = useState('0');
  const [total, setTotal] = useState('0')
  const [skr, setSkr] = useState('---');
  const [idantri, setIdantri] = useState('');
  const [printerlist, setPrinterlist] = useState([])
  const [printer, setPrinter] = useState('')

  // List Array
  const [agamalist, setAgamalist] = useState([])
  const [pekerjaanlist, setPekerjaanlist] = useState([])
  const [statuskeluargalist, setStatuskeluargalist] = useState([])
  const [profilfaskes, setProfilFaskes] = useState([])
  const [pasienList, setPasienList] = useState([])
  const [poliList, setPoliList] = useState([])
  const [pasienListToday, setPasienListToday] = useState([])



  useEffect(() => {
    onload()
    //getProvinsi()
    //console.log(url_faskes)
  }, [])

  const onload = async () => {
    await getAttr()

  }

  function show(value) {
    if (value === 1) {
      setShowmodal(true)
    } else {
      setShowmodal(false)
    }
  }

  const getAttr = async () => {
    //Set untuk memanggil antrian

    const _listagama = await getall({ table: 'table_agama' })
    const _listpekerjaan = await getall({ table: 'table_pekerjaan' })
    const _liststatus = await getall({ table: 'table_status' })
    const _profilfaskes = await getall({ table: 'table_faskes' })
    const _listpasien = await getall({ table: 'table_pasien' })

    setAgamalist(_listagama)
    setPekerjaanlist(_listpekerjaan)
    setStatuskeluargalist(_liststatus)
    setProfilFaskes(_profilfaskes)
    setPasienList(_listpasien)

    await getPoli(_profilfaskes[0].local_api)
    await pasientoday(_profilfaskes[0].local_api)

  }

  const getPoli = async (api) => {
    console.log("a")
    await axios.get(urldaskes + 'indexpendaftaran')
      .then(res => {
        setPoliList(res.data.poli)
        setPrinterlist(res.data.printer)
        setDipanggil(res.data.data.dipanggil);
        setSisa(res.data.data.sisa);
        setTotal(parseInt(res.data.data.dipanggil) + parseInt(res.data.data.sisa))
        console.log(res.data)
      })
  }

  const pasientoday = async (api) => {
    await axios.get(`${urldaskes}pasientoday`)
      .then(res => {
        console.log(res.data.datas)
        setPasienListToday(res.data.datas)
      })
  }

  const createPasien = async () => {
    const datas = {
      table: 'table_pasien',
      url: 'createpasien',
      payload: {
        rm,
        nik,
        bpjs,
        nama,
        jenis_kelamin,
        alamat,
        tempat_lahir,
        tanggal_lahir,
        no_hp,
        pekerjaan,
        agama,
        status,
        faskes_id,
        nama_kepala_keluarga
      }
    }
    const _create = await create(datas)
    if (_create === 1) {
      notification.open({
        message: 'Data Berhasil disimpan',
        description:
          '',
        icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
      });
      getAttr()
      // setPengikut('')
      show(0)
      reset()
    } else {
      notification.open({
        message: 'Gagal Menyimpan Data',
        description:
          'Data NIK atau RM sudah tersimpan di Database',
        icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
      });
    }
    console.log(datas)
  }

  const panggil = async () => {
    axios.get(urldaskes + "panggil/" + onesignalid + "/" + onesignalsec)
      .then(res => {
        if (res.data.status === '1') {
          if (res.data.dipanggil < 10) {
            setSkr('A00' + res.data.dipanggil)
          } else if (res.data.dipanggil > 9 && res.data.dipanggil < 100) {
            setSkr('A0' + res.data.dipanggil)
          } else {
            setSkr('A' + res.data.dipanggil)
          }

          setIdantri(res.data.data.kode_antrian)
          setDipanggil(res.data.dipanggil);
          setSisa(res.data.sisa);
          setTotal(parseInt(dipanggil) + parseInt(sisa))
          setPasien('')
          setPoli('')
        } else {
          notification.open({
            message: 'Antrian belum tersedia / habis ',
            description:
              '',
            icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
          });
        }
      })
    console.log(onesignalid + " --- " + onesignalsec)
  }

  function ulang() {
    axios.get(urldaskes + "ulangpanggil/A/" + dipanggil + "/" + onesignalid + "/" + onesignalsec)
      .then(res => {
        notification.open({
          message: 'Memanggil Ulang Antrian ',
          description:
            '',
          //icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
        });
      })
  }


  const login = () => {
    setLogin(true)
  }


  const reset = () => {
    setNik('');
    setRm('');
    setNama('');
    setBpjs('');
    setJenisKelamin('')
    setAlamat('');
    setTempatlahir('')//tempatlahir
    setTanggallahir('')//tanggal lahir
    setNohp('')//nohp
    setAgama('') //agama
    setPekerjaan('')//pelerjaan
    setStatus('')//status
    setFaskesId('')
    setNamakepalakeluarga('')//namakk
  }

  const simpanPasientoPoli = async () => {
    console.log(kodeAntrian)
    console.log(pasien)
    console.log(idantri)
    if (idantri === '' || pasien === '' || kodeAntrian === '') {
      notification.open({
        message: 'Terjadi kesalahan',
        description:
          'Pastikan semua syarat pendaftaran pasien ke poli terpenuhi',
        icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
      });
    } else {
      const datas = {
        kode_antrian: kodeAntrian,
        id_antrian: idantri,
        pasien: pasienforpoli
      }
      await axios.post(profilfaskes[0].local_api + 'antrianpoli', {
        datas
      })
        .then(res => {
          console.log(res.data.antrian)
          const open = window.open("http://localhost/printpos/printtransfer.php?nomor=" + res.data.antrian + "&rm=" + rm + "&printer=" + printer, '_blank', 'location=yes,height=100,width=100,scrollbars=yes,status=yes');
          setTimeout(() => { open.close() }, 5000);
          notification.open({
            message: 'Sukses',
            description:
              'Berhasil menambahkan antrian ke poli',
            icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
          });
          pasientoday(profilfaskes[0].local_api)
        })
    }
  }

  const tesPrint = () => {
    const open = window.open("http://localhost/printpos/print.php?nomor=0000&rm=Sukses&printer=" + printer, '_blank', 'location=yes,height=100,width=100,scrollbars=yes,status=yes');
    setTimeout(() => { open.close() }, 5000);
  }


  const onChangeTanggalLahir = (value, string) => {
    console.log(string)
    setTanggallahir(string)
  }

  const onChangeAgama = value => {
    setAgama(value)
  }

  const onChangePekerjaan = value => {
    setPekerjaan(value)
  }

  const onChangeStatus = value => {
    setStatus(value)
  }

  const onChangeJenisKelamin = value => {
    setJenisKelamin(value)
  }

  const onChangePasien = value => {
    setPasien(value)
    setPasienForPoli(pasienList[value])
  }

  const onChangePoli = value => {
    setPoli(value)
    setKodeAntrian(value)
  }

  const onChangePrinter = value => {
    setPrinter(value)

  }

  return (
    isLogin ? (
      <>
        <Row>
          <Col style={{ padding: 15 }} xs={24} sm={24} md={12} lg={12} xl={12}>
            <Card title="Antrian" style={{ width: '100%' }}>

              {/*  ====================================== Badges =======================================*/}

              <Row >
                <Col style={{ padding: 5 }} xs={24} sm={24} md={12} lg={8} xl={8}>
                  <Card style={{ width: '100%' }}>
                    <Row style={{ width: '100%' }}>
                      <Col style={{ width: '50%', alignItems: 'flex-end' }}><DatabaseTwoTone twoToneColor="#3498db" style={{ fontSize: 50 }} /></Col>
                      <Col style={{ width: '50%' }}>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 20 }}>{total}</Text>
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold' }}>Total Antrian</Text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col style={{ padding: 5 }} xs={24} sm={24} md={12} lg={8} xl={8}>
                  <Card style={{ width: '100%' }}>
                    <Row style={{ width: '100%' }}>
                      <Col style={{ width: '50%', alignItems: 'flex-end' }}><SoundTwoTone twoToneColor="#8e44ad" style={{ fontSize: 50 }} /></Col>
                      <Col style={{ width: '50%' }}>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 20 }}>{dipanggil}</Text>
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold' }}>Dipanggil</Text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col style={{ padding: 5 }} xs={24} sm={24} md={12} lg={8} xl={8}>
                  <Card style={{ width: '100%' }}>
                    <Row style={{ width: '100%' }}>
                      <Col style={{ width: '50%', alignItems: 'flex-end' }}><HeartTwoTone twoToneColor="#e74c3c" style={{ fontSize: 50 }} /></Col>
                      <Col style={{ width: '50%' }}>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 20 }}>{sisa}</Text>
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col style={{ width: '100%', alignItems: 'right' }}>
                            <Text style={{ fontWeight: 'bold' }}>Sisa Antrian</Text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Divider />
              {/*  ====================================== End Badges =======================================*/}
              {/*  ====================================== Button Panggil Ulang =======================================*/}
              <Row>
                <Col style={{ padding: 5, }} xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Button type="primary" style={{ width: '100%', height: 80 }} onClick={panggil}> Panggil </Button>
                </Col>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Button type="danger" style={{ width: '100%', height: 80 }} onClick={ulang}> Ulang </Button>
                </Col>
              </Row>
              {/*  ====================================== End Button Panggil Ulang =======================================*/}

              {/*  ====================================== Chart =======================================*/}
              {/*
              <Row style={{ width: "100%", marginTop: 50 }}>
                <Col tyle={{ width: "100%" }}>
                  <Chart
                    width={'700px'}
                    height={'300px'}
                    chartType="AreaChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      ['Year', 'Sales', 'Expenses'],
                      ['2013', 1000, 400],
                      ['2014', 1170, 460],
                      ['2015', 660, 1120],
                      ['2016', 1030, 540],
                    ]}
                    options={{
                      title: 'Grafik Kunjungan Pasien',
                      hAxis: { title: 'Year', titleTextStyle: { color: '#333' } },
                      vAxis: { minValue: 0 },
                      // For the legend to fit, we make the chart area smaller
                      chartArea: { width: '80%', height: '70%' },
                      // lineWidth: 25
                    }}
                  />
                </Col>
              </Row> */}

              {/*  ====================================== End Chart =======================================*/}



            </Card>
          </Col>
          <Col style={{ padding: 15 }} xs={24} sm={24} md={12} lg={12} xl={12}>
            <Card
              title="Data Pasien"
              style={{ width: '100%' }}
              extra={
                <Row style={{ width: '100%' }}>
                  <Col style={{ padding: 5 }} >
                    <Select
                      showSearch
                      style={{ width: '100%' }}
                      placeholder="Pilih Printer"
                      optionFilterProp="children"
                      onChange={onChangePrinter}
                      value={printer}
                    >
                      <Option value="">Pilih Printer</Option>
                      {printerlist.map((printer, index) =>
                        <Option value={printer.nama_printer}>{printer.loket}</Option>
                      )}
                    </Select>
                  </Col>
                  <Col style={{ padding: 5 }}>
                    <Button style={{ width: '100%' }} onClick={tesPrint}> Test Print </Button>
                  </Col>
                  <Col style={{ padding: 5 }}>
                    <Button type="primary" style={{ width: '100%' }} onClick={() => show(1)}> Tambah Pasien </Button>
                  </Col>
                </Row>
              }>
              {/* ======================================== Data Pasien ==================================== */}
              <Row style={{ width: '100%' }}>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={18} lg={18} xl={18}>
                  <span style={{ fontSize: 25, fonstWeight: 'bold', float: 'right' }}>Nomor Antrian</span>
                </Col>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={6} lg={6} xl={6}>
                  <span style={{ fontSize: 25, fonstWeight: 'bold' }}>{skr}</span>
                </Col>
                <Divider />
                <Col style={{ padding: 5 }} xs={24} sm={24} md={24} lg={24} xl={24} >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Pasien"
                    optionFilterProp="children"
                    onChange={onChangePasien}
                    value={pasien}
                  >
                    <Option value="">Pilih pasien berdasarkan nama / no RM / no BPJS</Option>
                    {
                      pasienList.map((item, index) =>
                        <Option value={index}>{item.rm} - {item.bpjs} -  {item.nama} - {item.alamat}</Option>
                      )
                    }
                  </Select>
                </Col>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Pasien"
                    optionFilterProp="children"
                    onChange={onChangePoli}
                    value={poli}
                  >
                    <Option value="">Pilih Poli</Option>
                    {
                      poliList.map((item, index) =>
                        <Option value={item.kode_antrian}>{item.nama_pelayanan}</Option>
                      )
                    }
                  </Select>
                </Col>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Radio.Group defaultValue="umum" style={{ float: 'right' }}>
                    <Radio.Button value="umum">Pasien Umum</Radio.Button>
                    <Radio.Button value="bpjs">Pasien BPJS</Radio.Button>
                  </Radio.Group>
                </Col>
                <Col style={{ padding: 5 }} xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Button type="primary" block style={{ width: '100%' }} onClick={simpanPasientoPoli}> Daftarkan Pasien ke Poli </Button>
                </Col>

                <Divider />
                <Row style={{ width: '100%', height: 400, overflow: 'auto' }}>
                  <table className="table1" style={{ width: '100%', fontSize: 12 }} >
                    <thead style={{ width: '100%', borderBottom: '1px solid black' }}>
                      <tr>
                        <td>No</td>
                        <td>RM</td>
                        <td>Nama</td>
                        <td>Antrian</td>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        pasienListToday.map((item, index) =>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.id_pasien}</td>
                            <td>{item.nama}</td>
                            <td>{item.nomor_poli}</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </Row>

                <Divider />
              </Row>

              {/* =====================================End Data Pasien====================================== */}
            </Card>
          </Col>
          {/* <Col style={{ backgroundColor: 'blue' }} xs={24} sm={24} md={24} lg={4} xl={4}>
            Col
          </Col> */}
        </Row>

        {/* ========================= Modal Tambah Pasien ============================ */}

        <Modal
          title="Tambah Pasien"
          visible={showmodal}
          width={800}
          onOk={createPasien}
          //confirmLoading={saveLoading}
          onCancel={() => show(0)}
        >
          <Form
            name="nest-messages"
            initialValues={{ remember: true }}
            layout={"vertical"}
          //onFinish={createFaskes}
          >
            <Row>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="nik"
                  {...configfield}
                  label="Nomor Induk Kependudukan (NIK)"
                >
                  <Input placeholder="Nama Induk Kependudukan (NIK)" value={nik} style={{ width: '100%' }} onChange={({ target }) => setNik(target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="normold"
                  {...configfield}
                  label="Nomor Rekam Medis Lama (Lokal)"
                >
                  <Input value={rm} style={{ width: '100%' }} onChange={({ target }) => setRm(target.value)} placeholder="Nomor Rekam Medis Lama / Lokal" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="namalengkap"
                  {...configfield}
                  label="Nama Lengkap"
                >
                  <Input value={nama} style={{ width: '100%' }} onChange={({ target }) => setNama(target.value)} placeholder="Nama Lengkap" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="jenikelamin"
                  {...configfield}
                  label="Jenis Kelamin"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Jenis Kelamin"
                    optionFilterProp="children"
                    onChange={onChangeJenisKelamin}
                    value={jenis_kelamin}
                  >
                    <Option value="Laki Laki">Laki Laki</Option>
                    <Option value="Perempuan">Perempuan</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="nobpjs"
                  {...configfield}
                  label="Nomor BPJS"
                >
                  <Input value={bpjs} style={{ width: '100%' }} onChange={({ target }) => setBpjs(target.value)} placeholder="Nama Lengkap" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="nohp"
                  {...configfield}
                  label="Nomor Telp / HP"
                >
                  <Input value={no_hp} style={{ width: '100%' }} onChange={({ target }) => setNohp(target.value)} placeholder="Nomor Telp / Hp" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="tempatlahir"
                  {...configfield}
                  label="Tempat Lahir"
                >
                  <Input value={tempat_lahir} style={{ width: '100%' }} onChange={({ target }) => setTempatlahir(target.value)} placeholder="Tempat Lahir" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item name="date-picker"   {...config} label="Tanggal Lahir"
                  rules={[{
                    required: true,
                    message: 'Please input website!'
                  }]}>
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={onChangeTanggalLahir}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="agama"
                  {...configfield}
                  label="Agama"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Agama"
                    optionFilterProp="children"
                    onChange={onChangeAgama}
                  >
                    {
                      agamalist.map((item, index) =>
                        <Option value={item.agama}>{item.agama}</Option>
                      )
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="pekerjaan"
                  {...configfield}
                  label="Pekerjaan"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Pekerjaan"
                    optionFilterProp="children"
                    onChange={onChangePekerjaan}
                  >
                    {
                      pekerjaanlist.map((item, index) =>
                        <Option value={item.pekerjaan}>{item.pekerjaan}</Option>
                      )
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="namakepalakeluadrga"
                  {...configfield}
                  label="Nama Kepala Keluarga"
                >
                  <Input value={nama_kepala_keluarga} style={{ width: '100%' }} onChange={({ target }) => setNamakepalakeluarga(target.value)} placeholder="Nama Kepala Keluarga" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="statusdalamkeluarga"
                  {...configfield}
                  label="Status Dalam Keluarga"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Status Dalam Keluarga"
                    optionFilterProp="children"
                    onChange={onChangeStatus}
                  >
                    {
                      statuskeluargalist.map((item, index) =>
                        <Option value={item.status}>{item.status}</Option>
                      )
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Form.Item
                  name="alamat"
                  label="Alamat"
                >
                  <Input value={alamat} style={{ width: '100%' }} onChange={({ target }) => setAlamat(target.value)} placeholder="Nama Kepala Keluarga" />
                </Form.Item>
              </Col>

            </Row>

            {/* <Form.Item rules={[{ required: true }]}>
              <Input.TextArea value={alamatfaskes} onChange={({ target }) => setAlamatFaskes(target.value)} />
            </Form.Item>
            <Form.Item rules={[{ required: true }]}>
              <Input.Password placeholder="Password" value={passwordfaskes} onChange={({ target }) => setPasswordFaskes(target.value)} />
            </Form.Item> */}
            {/* <Form.Item >
              <Button type="primary" htmlType="submit">
                Submit
                        </Button>
            </Form.Item> */}
          </Form>

        </Modal>

        {/* ======================== End Modal Tambah Pasien ========================= */}

      </>
    ) : (
        <div className="centering">
          <Card style={{ width: 400 }}>
            <center><img src='https://4.bp.blogspot.com/-_jU4QDr0b8w/W6hJbXJ_rqI/AAAAAAAAD4M/Xusle1pVasIdvI2Jc8rZBSrzelA4LgylgCLcBGAs/s1600/Logo%2BPuskesmas.png' style={{ width: 150, marginBottom:20 }} /></center>
            <Form
              name="basic"
              initialValues={{ remember: true }}
              style={{ width: '100%' }}
              onFinish={login}
            //onFinishFailed={onFinishFailed}
            >

              <Form.Item
                //label="Username"
                name="username"
                rules={[{ required: true, message: 'Please input your username!' }]}
              >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="User Name" />
              </Form.Item>

              <Form.Item
                //label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Password" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                  Login
                </Button>
              </Form.Item>

            </Form>
          </Card>
        </div>
      )
  );
}

export default App;
